var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Foundation/Icon/16px/chevron_left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron_Left"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7502 5.20594L8.03149 11.9242L14.7568 18.8008C15.0836 19.1349 15.0807 19.6737 14.7502 20.0041C14.4198 20.3346 13.887 20.3316 13.5602 19.9974L6.24317 12.5158C5.91637 12.1816 5.91934 11.6429 6.24981 11.3124L13.5669 3.99586C13.8973 3.66543 14.4301 3.66845 14.7569 4.00261C15.0836 4.33676 15.0806 4.87551 14.7502 5.20594Z",
    fill: "#1F2532"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_4649",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 3,
    width: 9,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7502 5.20594L8.03149 11.9242L14.7568 18.8008C15.0836 19.1349 15.0807 19.6737 14.7502 20.0041C14.4198 20.3346 13.887 20.3316 13.5602 19.9974L6.24317 12.5158C5.91637 12.1816 5.91934 11.6429 6.24981 11.3124L13.5669 3.99586C13.8973 3.66543 14.4301 3.66845 14.7569 4.00261C15.0836 4.33676 15.0806 4.87551 14.7502 5.20594Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_4649)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.a0c5fc8a0712f443c0d4d90fa4ae5d5b.svg";
export { ForwardRef as ReactComponent };